// ----------------- Helper: % of FRA Benefit -----------------
export function percentOfFRA(claim_age, FRA_age) {
  if (claim_age < FRA_age) {
    const monthsEarly = (FRA_age - claim_age) * 12;
    let reduction = 0;
    if (monthsEarly <= 36) {
      reduction = (monthsEarly * (5 / 9)) / 100;
    } else {
      reduction = (36 * (5 / 9) + (monthsEarly - 36) * (5 / 12)) / 100;
    }
    return 1 - reduction;
  } else {
    const monthsDelayed = (claim_age - FRA_age) * 12;
    return 1 + (monthsDelayed * (2 / 3)) / 100; // 8% per year
  }
}
// ----------------- Helper: Age at Break-even -----------------
export function ageAtBreakeven(claim_age, monthsToBreakEven) {
  const totalMonths = claim_age * 12 + monthsToBreakEven;
  const years = Math.floor(totalMonths / 12);
  const months = Math.round(totalMonths % 12);
  const formatted = `${years} years and ${months} months`;
  return { years, months, decimal: totalMonths / 12, formatted };
}

// ----------------- Helper: Future Value with TVM & COLA -----------------
export function futureValueAt70(monthlyBenefit, claim_age, cola, discountRate) {
  const months = (70 - claim_age) * 12;
  let fv = 0;

  for (let m = 1; m <= months; m++) {
    // monthly COLA adjustment
    const adjBenefit = monthlyBenefit * Math.pow(1 + cola, m / 12);
    // discount back to age 70
    fv += adjBenefit / Math.pow(1 + discountRate, (months - m) / 12);
  }
  return fv;
}

// ----------------- Main Row Calculation -----------------
export function calculateSSRow(
  claim_age,
  FRA_age,
  FRA_benefit,
  cola = 0.02,
  discountRate = 0.03
) {
  const monthsFromFRA = (claim_age - FRA_age) * 12;
  const pctFRA = percentOfFRA(claim_age, FRA_age);
  const monthlyBenefit = FRA_benefit * pctFRA;

  // Without TVM
  const benefitAt70 = FRA_benefit * percentOfFRA(70, FRA_age);

  let totalBenefit = 0;
  let monthsToBE = 0;
  let ageAtBE = claim_age;
  let ageAtBE_formated = "";
  if (claim_age < 70) {
    totalBenefit = monthlyBenefit * (70 - claim_age) * 12;
    const denom = benefitAt70 - monthlyBenefit;

    if (denom > 0) {
      monthsToBE = totalBenefit / denom;
      const breakeven = ageAtBreakeven(claim_age, monthsToBE);
      ageAtBE = breakeven.decimal;
      ageAtBE_formated = breakeven.formatted;
      // ageAtBE = claim_age + monthsToBE / 12;
    }
  }

  // With TVM + COLA
  let fvAt70 = 0;
  let monthsToBE_COLA = 0;
  let ageAtBE_COLA = claim_age;
  let ageAtBE_COLA_formated = "";
  if (claim_age < 70) {
    fvAt70 = futureValueAt70(monthlyBenefit, claim_age, cola, discountRate);
    const denom = benefitAt70 - monthlyBenefit;
    if (denom > 0) {
      monthsToBE_COLA = fvAt70 / denom;
      const breakevenCOLA = ageAtBreakeven(claim_age, monthsToBE_COLA);
      ageAtBE_COLA = breakevenCOLA.decimal;
      ageAtBE_COLA_formated = breakevenCOLA.formatted;
      // ageAtBE_COLA = claim_age + monthsToBE_COLA / 12;
    }
  }

  const result = {
    "Age to take Social Security": claim_age,
    "Months from Full Retirement Age": monthsFromFRA,
    "% of FRA Benefit": (pctFRA * 100).toFixed(2),
    "Monthly Benefit": monthlyBenefit.toFixed(2),
    "Total benefit received up to Age 70": totalBenefit.toFixed(2),
    "Months to break-even with age 70": monthsToBE.toFixed(2),
    "Age at Break-even": ageAtBE.toFixed(2),
    "Age at Break-even-formated": ageAtBE_formated,
    "Future value at 70 of pre-70 benefit": fvAt70.toFixed(2),
    "Months to break even with age 70 (TVM+COLA)": monthsToBE_COLA.toFixed(1),
    "Age at Break-even (TVM+COLA)": ageAtBE_COLA.toFixed(2),
    "Age at Break-even-COLA-formated": ageAtBE_COLA_formated,
  };

  return result;
}

// ----------------- Generate Full Table (62 → 70) -----------------
export function generateAtAge70SSTable(
  claim_age,
  FRA_age,
  FRA_benefit,
  cola = 0.02,
  discountRate = 0.03
) {
  const rows = [];
  for (let age = 62; age < claim_age; age++) {
    rows.push(calculateSSRow(age, FRA_age, FRA_benefit, cola, discountRate));
  }
  return rows;
}
